var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status !== 'on')?_c('live-time',{attrs:{"timestamp":_vm.timestamp}}):_c('span',[_vm._v("now")])}
var staticRenderFns = []

export { render, staticRenderFns }